import { render, staticRenderFns } from "./PlayerRanking.vue?vue&type=template&id=1c278466&scoped=true"
import script from "./PlayerRanking.vue?vue&type=script&lang=js"
export * from "./PlayerRanking.vue?vue&type=script&lang=js"
import style0 from "./PlayerRanking.vue?vue&type=style&index=0&id=1c278466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c278466",
  null
  
)

export default component.exports